import { Text, Theme, useStyles } from 'bold-ui'
import moment from 'moment'
import React, { CSSProperties } from 'react'

import { MedicaoProntuarioModel } from '../../types/MedicaoModel'

interface MedicoesDescriptionProps {
  values: MedicaoProntuarioModel[]
  unidadeMedida?: string
  isMedicaoAnterior?: boolean
}

const asFormatDate = (val) => moment(val).format('DD/MM/YYYY')
const asFormatTime = (val) => moment(val).format('HH[h]mm[min]')
const asFormatDateTime = (val) => moment(val).format('DD/MM/YYYY | HH[h]mm[min]')

export const MedicoesDescription = (props: MedicoesDescriptionProps) => {
  const { values, unidadeMedida, isMedicaoAnterior } = props
  const { classes } = useStyles(createStyles, props)

  return (
    <>
      {values.map((item, index, array) => (
        <Text style={classes.content} key={item.key}>
          {`${item.valor} ${unidadeMedida || ''}`}
          <span className={classes.obs}>
            {' '}
            {`${item.observacao ? '(' + item.observacao + ')' : ''} 
                ${!isMedicaoAnterior && array.length > 1 ? `- ${asFormatTime(item.dataMedicao)}` : ''}
                ${
                  isMedicaoAnterior
                    ? array.length > 1
                      ? `- ${asFormatDateTime(item.dataMedicao)}`
                      : `- ${asFormatDate(item.dataMedicao)}`
                    : ''
                }
              `}
          </span>
        </Text>
      ))}
    </>
  )
}

export const createStyles = (theme: Theme, { values }: MedicoesDescriptionProps) => ({
  content: {
    display: `${values.length > 1 ? 'block' : 'inline'}`,
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  } as CSSProperties,
  obs: {
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  } as CSSProperties,
})
